"use strict";

exports.__esModule = true;
var _behaviors = require("./behaviors");
Object.keys(_behaviors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _behaviors[key]) return;
  exports[key] = _behaviors[key];
});
var _layout = require("./layout");
Object.keys(_layout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _layout[key]) return;
  exports[key] = _layout[key];
});
//# sourceMappingURL=index.js.map